export default __webpack_public_path__ + "static/media/arrows.073db6d0.svg";